class BannerRequest {
    constructor(ctx) {
        this._ctx = ctx;
        this._apntag = ctx.apntag;
    }

    // APPNEXUS: define + load TAG
    perform() {
        this._apntag.anq.push(() => {
            for (const tag in this._ctx.appNexusData.tags) {
                if (this._ctx.appNexusData.tags.hasOwnProperty(tag)) {
                    const tagObj = this._ctx.appNexusData.tags[tag];
                    this._apntag.defineTag(tagObj);
                }
            }

            this._apntag.loadTags();
        });
    }
}

export default BannerRequest;



// WEBPACK FOOTER //
// ./services/banner2/BannerRequest.js